import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {HttpModule} from '@angular/http';
import {FormsModule} from '@angular/forms';
import {AbsDropdownModule} from '../abs-dropdown/abs-dropdown.module';

import {AbsTablesComponent} from './abs-tables.component';
import {AbsResponsiveRowComponent} from './abs-responsive-row.component';
import {AbsSummaryTableDirective} from './abs-summary-table.directive';
import {TableBodyComponent} from './abs-table-body.component';
import {AbsTableHeaderComponent} from './abs-table-header.component';
import { SortingPipe } from './abs-sorting.pipe';

@NgModule({
  imports: [CommonModule, HttpModule, FormsModule,AbsDropdownModule],
  declarations: [AbsTablesComponent,AbsResponsiveRowComponent,AbsSummaryTableDirective,TableBodyComponent,AbsTableHeaderComponent, SortingPipe],
  exports:[AbsTablesComponent,AbsResponsiveRowComponent,AbsSummaryTableDirective,TableBodyComponent,AbsTableHeaderComponent,SortingPipe]
})
export class AbsTablesModule { }
